<ng-template ngFor let-set let-i="index" [ngForOf]="match.sets">
    <ion-col class="ion-text-center">
        {{ match | gameScore:{setIndex: i, sideNumber} }}<sup>{{ getTiebreakScore(i) }}</sup>
    </ion-col>
</ng-template>